import { render, staticRenderFns } from "./PosturaChildsDead.vue?vue&type=template&id=be673bb8"
import script from "./PosturaChildsDead.vue?vue&type=script&lang=js"
export * from "./PosturaChildsDead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports